<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-portlet__head">
      <div class="kt-portlet__head-label">
        <h3 class="kt-portlet__head-title">
          <i class="fas fa-clipboard-check"></i>
          สรุปผลการสร้างเอกสารรวม
        </h3>
      </div>
    </div>

    <div class="kt-portlet__body">
      <!-- begin: Stepper (บันทึกแล้ว — ครบทั้ง 3 ขั้น) -->
      <!--
        FS-111 (16/10/2026) — ใช้ stepper ตัวเดียวกับหน้าเลือก 1 ราย (FormSummaryStockDetail.vue)
          เดิมเป็น breadcrumb ตัวหนังสือ "1. เลือกเงื่อนไข › 2. ตรวจสอบข้อมูล › 3. สรุปผล"
          ซึ่งไม่เหมือนขั้นอื่นของโมดูล
      -->
      <div class="row">
        <div class="col-12">
          <div class="fss-stepper" data-test="fss-result-stepper">
            <div class="fss-step fss-step--done">
              <div class="fss-step__badge">&#10003;</div>
              <div class="fss-step__title">เลือก Filter</div>
            </div>
            <div class="fss-connector fss-connector--all-done"></div>
            <div class="fss-step fss-step--done">
              <div class="fss-step__badge">&#10003;</div>
              <div class="fss-step__title">ตรวจสอบข้อมูล</div>
            </div>
            <div class="fss-connector fss-connector--all-done"></div>
            <div class="fss-step fss-step--done">
              <div class="fss-step__badge">&#10003;</div>
              <div class="fss-step__title">บันทึกแล้ว</div>
            </div>
          </div>
        </div>
      </div>
      <!-- end: Stepper -->

      <div v-if="loadError" class="alert alert-danger" data-test="fss-result-error">
        {{ loadError }}
      </div>

      <template v-else>
        <!-- begin: หัวเรื่องสรุป -->
        <div class="fss-result__summary">
          <!-- FS-032 ข้อ 5 — ข้อความตาม design: บอกว่า "สำเร็จทั้งหมด" และ "พร้อมดาวน์โหลด/พิมพ์"
               เพื่อชี้ไปที่งานถัดไปที่ผู้ใช้ต้องทำ ไม่ใช่แค่รายงานว่าบันทึกเสร็จ -->
          <!-- FS-112 ข้อ 3 — แถบพื้นเขียว ตัวขาว มุมโค้ง ตาม mockup ฉบับเซ็น (ขั้นที่ 6 .doc-info-bar) -->
          <div class="fss-result__headline" data-test="fss-result-headline">
            ✔ <strong>สร้างสำเร็จทั้งหมด
            <span class="fss-result__count">{{ documentCount }}</span>
            เอกสารสรุปสินค้าคงค้าง</strong> — พร้อมดาวน์โหลด / พิมพ์
          </div>
          <!-- FS-112 ข้อ 2 — ตัด "วันเวลาที่ประมวลผล" ออก (ผู้ใช้สั่ง 16/10/2026) -->
        </div>
        <!-- end: หัวเรื่องสรุป -->

        <!-- begin: Filter ที่เลือก -->
        <!--
          FS-121 (19/10/2026) — หน้าตาเดียวกับขั้นที่ 2 (FormSummaryStockGroupPreview.vue "Filter ที่เลือก")
            หัวข้อ h5 + ตาราง ป้าย | ค่าจริง ทีละ filter · แทนบรรทัดเดียวของ FS-114
            ("Filter ที่ใช้สร้างเอกสารชุดนี้: ... · 2 ตัวแทนจำหน่าย · รหัสสินค้า 2 รายการ" ที่บอกแค่จำนวน)
            ข้อมูลจาก filterLabels ของ API GroupResult (server แปลงรหัสเป็นข้อความแบบ dropdown ขั้นที่ 1)
        -->
        <div class="fss-result__filter" data-test="fss-result-filter">
          <h5 class="kt-font-bold kt-margin-b-10">Filter ที่เลือก</h5>
          <table v-if="filterLabels.length > 0" class="table table-sm fss-filter-table">
            <tbody>
              <tr v-for="(item, index) in filterLabels" :key="index" data-test="fss-result-filter-line">
                <td class="fss-filter-table__label">{{ item.label }}</td>
                <td>{{ item.text }}</td>
              </tr>
            </tbody>
          </table>
          <div v-else class="text-muted">-</div>
        </div>
        <!-- end: Filter ที่เลือก -->

        <!-- begin: ปุ่มดาวน์โหลดทั้งชุด -->
        <div class="fss-result__bulk">
          <!--
            J2 เสร็จครบแล้ว — ZIP ทั้งฝั่ง Excel และ PDF ใช้งานได้จริง
            ทั้งสองปุ่มใช้ popup ความคืบหน้าตัวเดียวกัน (F14) ต่างแค่ endpoint ที่เริ่มงาน
          -->
          <button
            type="button"
            class="btn btn-sm btn-success kt-margin-r-10"
            data-test="fss-result-zip-excel"
            :disabled="documentCount === 0"
            title="ดาวน์โหลดไฟล์ ZIP รวม Excel ของทุกเอกสารในชุดนี้"
            @click="exportZipExcel"
          >
            <i class="la la-file-excel-o"></i>
            <!-- FS-052 — ชื่อปุ่มตาม spec หัวข้อ B: "Export Excel {N} เอกสาร (รายละเอียดบาร์โค้ด)"
                 ของเดิมขาดวงเล็บท้าย ทำให้ไม่ตรงกับชื่อที่ popup เตือนงานค้างใช้เรียก -->
            Export Excel {{ documentCount }} เอกสาร (รายละเอียดบาร์โค้ด)
          </button>

          <button
            type="button"
            class="btn btn-sm fss-btn fss-btn--orange kt-margin-r-10"
            data-test="fss-result-zip-pdf"
            :disabled="documentCount === 0"
            title="ดาวน์โหลดไฟล์ ZIP รวมฟอร์ม PDF ของทุกเอกสารในชุดนี้"
            @click="exportZipPdf"
          >
            <!-- FS-112 ข้อ 1 — สีส้มเดียวกับปุ่มพิมพ์ PDF ในหน้า list (fss-act--orange #F59E0B)
                 FS-115 — ต้องมีคลาสฐาน fss-btn ด้วย (ตัวอักษรขาว) แบบเดียวกับหน้ารายละเอียด -->
            <i class="la la-print"></i>
            พิมพ์ PDF {{ documentCount }} เอกสาร
          </button>

          <span class="fss-result__bulk-note">
            ดาวน์โหลดทั้งชุดเป็นไฟล์ ZIP ครั้งเดียว —
            หรือเปิดเอกสารทีละฉบับจากตารางด้านล่างก็ได้
          </span>
        </div>
        <!-- end: ปุ่มดาวน์โหลดทั้งชุด -->

        <!-- begin: ค้นหาตัวแทนจำหน่ายในตาราง (FS-032 ข้อ 3)
             กรองฝั่ง client ล้วน — ข้อมูลทั้งชุดถูกโหลดมาครบตั้งแต่เปิดหน้าแล้ว
             ชุดใหญ่สุดตาม spec คือ 55-60 แถว จึงไม่คุ้มที่จะยิง API ใหม่ทุกครั้งที่พิมพ์ -->
        <div class="fss-result__search">
          <div class="input-group input-group-sm fss-result__search-box">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="la la-search"></i></span>
            </div>
            <input
              type="text"
              class="form-control"
              data-test="fss-result-search"
              v-model="agentKeyword"
              placeholder="ค้นหารหัส/ชื่อตัวแทนจำหน่าย..."
            />
            <div class="input-group-append" v-if="agentKeyword">
              <button
                type="button"
                class="btn btn-secondary"
                data-test="fss-result-search-clear"
                title="ล้างคำค้น"
                @click="agentKeyword = ''"
              >
                <i class="la la-close"></i>
              </button>
            </div>
          </div>

          <span
            v-if="agentKeyword"
            class="fss-result__search-count"
            data-test="fss-result-search-count"
          >
            แสดง {{ filteredDocuments.length }} จาก {{ documents.length }} รายการ
          </span>
        </div>
        <!-- end: ค้นหาตัวแทนจำหน่ายในตาราง -->

        <!-- begin: ตารางเอกสาร -->
        <!--
          FS-121 (19/10/2026) — รูปแบบเดียวกับตารางขั้นที่ 2 (FormSummaryStockGroupPreview.vue)
            ปุ่มกาง (›) ดูรายละเอียดสินค้า · ลำดับ · ชื่อตัวแทน + บรรทัดสาขา (FS-106) ·
            เลขที่เอกสาร (ลิงก์เดิม FS-032 — วางก่อนจำนวนตามที่ผู้ใช้สั่ง) · จำนวนคงค้าง · ยอดรวม ·
            แถว Grand Total "สร้างแล้ว N เอกสาร จากทั้งหมด N ตัวแทนจำหน่าย" (ผู้ใช้เลือกคำแบบ ข)
          FS-053 ข้อ 3 — ไม่มีคอลัมน์ปุ่มแว่นขยาย (เลขที่เอกสารเป็นลิงก์อยู่แล้ว)
        -->
        <div class="table-responsive">
          <table class="table table-sm table-bordered table-hover fss-result__table">
            <thead>
              <tr>
                <th class="text-center" style="width: 5%;"></th>
                <th class="text-center" style="width: 7%;">ลำดับ</th>
                <th class="text-center">ชื่อตัวแทนจำหน่าย</th>
                <th class="text-center" style="width: 14%;">เลขที่เอกสาร</th>
                <th class="text-center" style="width: 13%;">จำนวนคงค้าง</th>
                <th class="text-center" style="width: 18%;">ยอดรวม (ก่อน VAT)</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="doc in filteredDocuments">
                <tr :key="doc.id" data-test="fss-result-row">
                  <td class="text-center">
                    <button
                      type="button"
                      class="btn btn-sm btn-clean btn-icon btn-icon-md"
                      data-test="fss-result-expand"
                      :title="isExpanded(doc.id) ? 'ซ่อนรายละเอียด' : 'แสดงรายละเอียด'"
                      @click="toggleDetail(doc.id)"
                    >
                      <i :class="isExpanded(doc.id) ? 'la la-angle-down' : 'la la-angle-right'"></i>
                    </button>
                  </td>
                  <td class="text-center">{{ doc.seqNo }}</td>
                  <!-- FS-053 ข้อ 1 — "[รหัส] ชื่อ" · FS-121 — สีเดียวกับขั้นที่ 2 (เดิมรหัสสีเทา) -->
                  <td>
                    {{ agentLabel(doc) }}
                    <div v-if="doc.branchLine" class="fss-branch-line" data-test="fss-result-branch-line">
                      {{ doc.branchLine }}
                    </div>
                  </td>
                  <td class="text-center">
                    <!-- FS-032 ข้อ 2 — เลขที่เอกสารต้องเป็นลิงก์ที่ "เปิดแท็บใหม่"
                         href จริงไว้ให้คลิกกลางปุ่ม/copy link ได้ ส่วนคลิกปกติใช้ viewDocument -->
                    <a
                      :href="documentUrl(doc)"
                      class="fss-result__doc-link"
                      data-test="fss-result-doc-link"
                      target="_blank"
                      rel="noopener"
                      title="เปิดเอกสารในแถบใหม่"
                      @click.prevent="viewDocument(doc)"
                    >{{ doc.documentNo }}</a>
                  </td>
                  <td class="text-right">{{ formatQty(doc.totalQty) }}</td>
                  <td class="text-right">{{ formatAmount(doc.totalAmount) }}</td>
                </tr>

                <!-- แถวรายละเอียดระดับสินค้า — ค่าเริ่มต้นพับไว้ (เหมือนขั้นที่ 2) -->
                <tr
                  v-if="isExpanded(doc.id)"
                  :key="doc.id + '__detail'"
                  class="fss-detail-row"
                  data-test="fss-result-detail-row"
                >
                  <td colspan="6">
                    <div class="fss-detail">
                      <div class="fss-detail__title">
                        รายละเอียดสินค้าคงค้าง — {{ doc.agentName || doc.agentCode }}
                      </div>
                      <div class="table-responsive">
                        <table class="table table-sm table-striped table-bordered">
                          <thead>
                            <tr>
                              <th class="text-center" style="width: 7%;">ลำดับ</th>
                              <th class="text-center" style="width: 18%;">ประเภทสินค้า</th>
                              <th class="text-center" style="width: 15%;">รหัสสินค้า</th>
                              <th class="text-center" style="width: 27%;">ชื่อสินค้า</th>
                              <th class="text-center" style="width: 12%;">จำนวนคงค้าง</th>
                              <th class="text-center" style="width: 8%;">หน่วย</th>
                              <th class="text-center" style="width: 13%;">จำนวนเงิน (ก่อน VAT)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(row, index) in doc.details || []" :key="index">
                              <td class="text-center">{{ row.seqNo }}</td>
                              <td>{{ row.productTypeName }}</td>
                              <td>{{ row.productCode }}</td>
                              <td>{{ row.productName }}</td>
                              <td class="text-right">{{ formatQty(row.qty) }}</td>
                              <td class="text-center">{{ row.unitName }}</td>
                              <td class="text-right">{{ formatAmount(row.amount) }}</td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr class="fss-total-row">
                              <td colspan="4" class="text-right kt-font-bold">Grand Total</td>
                              <td class="text-right kt-font-bold">{{ formatQty(doc.totalQty) }}</td>
                              <td class="text-center">—</td>
                              <td class="text-right kt-font-bold">{{ formatAmount(doc.totalAmount) }}</td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>

              <!-- คำค้นไม่ตรงใคร — ต้องบอกให้ชัด ไม่ปล่อยตารางว่างเปล่าจนดูเหมือนข้อมูลหาย -->
              <tr v-if="filteredDocuments.length === 0" data-test="fss-result-search-empty">
                <td colspan="6" class="text-center fss-result__empty">
                  ไม่พบตัวแทนจำหน่ายที่ตรงกับ "{{ agentKeyword }}"
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="fss-total-row" data-test="fss-result-grand-total">
                <td colspan="4" class="text-right kt-font-bold">
                  Grand Total (สร้างแล้ว {{ documentCount }} เอกสาร
                  จากทั้งหมด {{ documentCount }} ตัวแทนจำหน่าย)
                </td>
                <td class="text-right kt-font-bold">{{ formatQty(totalQty) }}</td>
                <td class="text-right kt-font-bold">{{ formatAmount(totalAmount) }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <!-- end: ตารางเอกสาร -->

        <!-- begin: แถบเตือน "แสดงเพียงครั้งเดียว" (FS-032 ข้อ 4)
             ต้องอยู่ในหน้าตั้งแต่แรก ไม่ใช่รอไปเตือนใน popup ตอนผู้ใช้จะออก
             เพราะถึงตอนนั้นผู้ใช้ตัดสินใจจะออกไปแล้ว เตือนช้าไป -->
        <div class="fss-result__once" data-test="fss-result-once-warning">
          <i class="fas fa-exclamation-circle"></i>
          <span>
            <strong>หน้าสรุปนี้แสดงเพียงครั้งเดียว</strong> —
            <!-- FS-052 — ต้องเรียกชื่อปุ่มให้ตรงกับที่เขียนบนปุ่มจริง -->
            โปรดกด
            <strong>"Export Excel {{ documentCount }} เอกสาร (รายละเอียดบาร์โค้ด)"</strong>
            หรือ <strong>"พิมพ์ PDF {{ documentCount }} เอกสาร"</strong> ก่อนออกจากหน้า
            (เอกสารแต่ละฉบับยังคงเปิดดูได้จากเมนู <strong>"รายการเอกสาร"</strong>)
          </span>
        </div>
        <!-- end: แถบเตือน "แสดงเพียงครั้งเดียว" -->

        <div class="kt-separator kt-separator--border-dashed kt-separator--space-sm"></div>

        <div class="row">
          <!-- FS-053 ข้อ 4 — ปุ่ม "กลับสู่หน้าค้นหา" ย้ายมาอยู่ฝั่งซ้าย
               แพตเทิร์นเดียวกับปุ่ม "กลับไปที่รายการเอกสาร" ของหน้ารายละเอียด -->
          <div class="col-xl-12 text-left">
            <button
              type="button"
              class="btn btn-sm btn-clean"
              data-test="fss-result-goto-list"
              @click="leaveToList"
            >
              <i class="la la-arrow-left"></i>
              <!-- FS-032 ข้อ 5 — ชื่อปุ่มตาม design (ปลายทางยังเป็นหน้าค้นหาเอกสารเดิม
                   ตัวเดียวกับปุ่ม "กลับไปที่ค้นหา..." ของหน้ารายละเอียดเอกสาร) -->
              <span class="kt-hidden-mobile">กลับสู่หน้าค้นหา</span>
            </button>
          </div>
        </div>
      </template>

      <!-- F14 — popup ความคืบหน้า ใช้ซ้ำกับงานสร้าง ZIP (F13 J2)
           FS-019: ต้องรู้ว่างาน ZIP จบแบบสำเร็จจริงไหม จึงดักเหตุการณ์ finished ไว้ -->
      <FormSummaryStockProgressModal ref="progressModal" @finished="onZipFinished" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
// Action Button Design System + Stepper ของโมดูลนี้ (QA เรื่องที่ 11 + 16)
import "./form-summary-stock-actions.css";
// FS-088 — tooltip ของปุ่มวงกลมเป็นแบบ Bootstrap (ผูกครั้งเดียวทั้งโมดูล เรียกซ้ำได้)
import { installFssTooltips } from "./form-summary-stock-tooltips";
installFssTooltips();
import router from "../../router";
import FormSummaryStockProgressModal from "./FormSummaryStockProgressModal";

require("sweetalert2");

// ─────────────────────────────────────────────────────────────────────────────
// CR-FormSummaryStock F13 (J1) — ขั้นที่ 6 "สรุปผลการสร้างเอกสารรวม"
//   /PrintSummary/Barcodes/GroupResult
//
// รับ batchId ทาง route params ของ named route (ไม่ใช่ query string และไม่ใช่ $parent
//   เพราะ route นี้เป็น sibling ของ "New" — $parent คือหน้ารายการ)
//   spec ฉบับเซ็น 16/09/2026 ระบุว่าเป็น "หน้าชั่วคราว แสดงเพียงครั้งเดียว —
//   หากปิดหน้าจอไปแล้ว จะไม่สามารถเปิดหน้าสรุปเดียวกันขึ้นมาดูซ้ำได้"
//   ถ้ารับทาง query string จะ refresh/bookmark เปิดซ้ำได้ ซึ่งขัดกับ spec ข้อนี้
//   (เคยทำแบบนั้นไว้ — ผู้ใช้ตัดสินให้ยึด spec เมื่อ 25/09/2026)
//
// ── popup เตือนก่อนออกจากหน้า (spec บังคับ) ─────────────────────────────────
//   ออกจากหน้านี้แล้วต้องไปหาเอกสารทีละฉบับในหน้ารายการ จึงต้องเตือนก่อน
//   ครอบ 2 ทาง:
//     1. เปลี่ยน route ภายใน SPA  -> beforeRouteLeave
//     2. ปิดแท็บ / refresh / กด back -> beforeunload
//   ปุ่ม "กลับสู่หน้าค้นหา" ถือว่าผู้ใช้ตั้งใจออกแล้ว จึงข้ามการเตือน
//   ส่วนการคลิกเลขที่เอกสาร (FS-032) เปิดแท็บใหม่ = ยังอยู่หน้าเดิม จึงห้ามตั้ง leaveConfirmed
//
//   FS-019 — สาระของ popup นี้คือกันผู้ใช้ลืมดาวน์โหลด ZIP จึงต้องบอกด้วยว่า
//   "ยังไม่ได้ทำอะไรบ้าง" ไม่ใช่เตือนลอย ๆ ดู zipExcelDone / zipPdfDone
//   ข้อความของ beforeunload แก้ไม่ได้ (เบราว์เซอร์บังคับข้อความมาตรฐานของตัวเอง)
//   ส่วนนี้จึงมีผลเฉพาะเส้นทาง beforeRouteLeave
//
// SweetAlert2 = ^8.2.3 → ใช้ option ชื่อ `type` และอ่านผลจาก `result.value`
//   v8 รองรับ reverseButtons / focusCancel แล้ว (ใช้สลับให้ "ยังอยู่หน้านี้" เป็นปุ่มหลัก)
// ─────────────────────────────────────────────────────────────────────────────

export default {
  components: { FormSummaryStockProgressModal },
  data: function() {
    return {
      batchId: "",
      documents: [],
      documentCount: 0,
      totalQty: 0,
      // FS-121 — ยอดรวมแถว Grand Total · Filter ที่เลือกแบบขั้นที่ 2 · แถวที่กางรายละเอียดอยู่ (key = doc.id)
      totalAmount: 0,
      filterLabels: [],
      expandedDocs: {},
      filter: null,
      loadError: "",

      // true = ผู้ใช้กดปุ่มออกเอง ไม่ต้องเตือนซ้ำ
      leaveConfirmed: false,

      // FS-032 — คำค้นของช่อง "ค้นหารหัส/ชื่อตัวแทนจำหน่าย" เหนือตาราง (กรองฝั่ง client)
      agentKeyword: "",

      // ── FS-019 : จำว่างาน ZIP ฝั่งไหน "สำเร็จจริง" ไปแล้วบ้าง ──────────────
      //   ใช้ตัดสินว่าจะขึ้นกล่องเตือนงานค้างใน popup ก่อนออกจากหน้าหรือไม่
      //   เงื่อนไขที่นับว่าทำแล้ว = งานจบด้วยสถานะ Completed และมีไฟล์ผลลัพธ์จริง
      //   (แค่ "กดปุ่ม" ไม่นับ — งานอาจล้ม ถูกยกเลิก หรือขาดการติดต่อกลางทาง)
      zipExcelDone: false,
      zipPdfDone: false,

      // ฝั่งของงาน ZIP ที่กำลังรันอยู่ ("excel" / "pdf")
      //   popup ความคืบหน้าใช้ตัวเดียวกันทั้ง 2 ฝั่ง และไม่ได้บอกกลับมาว่าเป็นงานอะไร
      zipJobKind: "",
    };
  },
  computed: {
    // FS-032 — แถวที่ผ่านคำค้น
    //   ค้นได้ทั้งรหัสและชื่อตัวแทน (ผู้ใช้จำได้อย่างใดอย่างหนึ่ง)
    //   ตัด case ทิ้งเพราะรหัสบางรายมีตัวอักษรปน · ตัดช่องว่างหัวท้ายกัน paste ติดมา
    //   ไม่แตะ seqNo ของแถว — เลขลำดับต้องเป็นลำดับเดิมของทั้งชุด ไม่ใช่ลำดับในผลค้นหา
    filteredDocuments: function() {
      const keyword = (this.agentKeyword || "").trim().toLowerCase();
      if (!keyword) return this.documents;

      return this.documents.filter(function(doc) {
        const haystack = (
          (doc.agentCode || "") + " " + (doc.agentName || "")
        ).toLowerCase();
        return haystack.indexOf(keyword) !== -1;
      });
    },

    // FS-019 — รายการงานที่ "ยังไม่ได้ทำ" สำหรับกล่องเหลืองใน popup ก่อนออกจากหน้า
    //   ไม่มีเอกสารเลย = ไม่มีงานให้ทำ (ปุ่ม ZIP ทั้งคู่ถูก disable อยู่แล้ว)
    pendingZipTasks: function() {
      if (this.documentCount === 0) return [];

      const tasks = [];

      if (!this.zipExcelDone) {
        tasks.push({
          key: "excel",
          text:
            "Export Excel " +
            this.documentCount +
            " เอกสาร (รายละเอียดบาร์โค้ด) — ดาวน์โหลด ZIP",
        });
      }

      if (!this.zipPdfDone) {
        tasks.push({
          key: "pdf",
          text: "พิมพ์ PDF " + this.documentCount + " เอกสาร — ดาวน์โหลด ZIP",
        });
      }

      return tasks;
    },
  },
  methods: {
    // FS-121 — ฟังก์ชันชุดเดียวกับขั้นที่ 2 (FormSummaryStockGroupPreview.vue)
    formatQty: function(value) {
      if (value == null || value === "") return "-";
      return Number(value).toLocaleString("en-US");
    },
    agentLabel: function(doc) {
      if (!doc) return "-";
      if (!doc.agentName) return "[" + doc.agentCode + "]";
      return "[" + doc.agentCode + "] " + doc.agentName;
    },
    isExpanded: function(id) {
      return this.expandedDocs[id] === true;
    },
    // Vue 2 ไม่ตรวจจับการเพิ่ม key ใหม่ในอ็อบเจกต์ → ต้องใช้ $set
    toggleDetail: function(id) {
      this.$set(this.expandedDocs, id, !this.isExpanded(id));
    },

    formatAmount: function(value) {
      if (value == null || value === "") return "-";
      return Number(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    loadResult: function() {
      const self = this;

      // params ของ named route อยู่แค่ในหน่วยความจำ — refresh แล้วค่านี้หายตามตั้งใจ
      self.batchId = self.$route.params.batchId || "";

      if (!self.batchId) {
        // เข้าตรง / refresh / กด back กลับมา = ไม่มี state แล้ว ตาม spec ห้ามเปิดซ้ำ
        // เด้งกลับหน้ารายการเงียบ ๆ ไม่ต้องขึ้น error ให้ผู้ใช้ตกใจ
        // (leaveConfirmed กัน popup เตือนเด้งซ้อนตอนเปลี่ยน route)
        self.leaveConfirmed = true;
        router.replace({ path: "/PrintSummary/Barcodes" });
        return;
      }

      KTApp.blockPage({ opacity: 0.05, message: "กำลังโหลดข้อมูล..." });

      axios
        .post(
          "/Api/FormSummaryStock/GroupResult",
          { batchId: self.batchId },
          { headers: { Authorization: "Bearer " + self.$root.user.access_token } }
        )
        .then(function(response) {
          const data = (response && response.data) || {};

          if (!data.success) {
            self.loadError = data.message || "ไม่พบข้อมูลชุดเอกสารนี้";
            return;
          }

          self.documents = data.documents || [];
          self.documentCount = data.documentCount || 0;
          self.totalQty = data.totalQty || 0;
          self.totalAmount = data.totalAmount || 0;
          self.filterLabels = data.filterLabels || [];
          self.filter = data.filter || null;
          self.loadError = "";
        })
        .catch(function() {
          self.loadError = "เกิดข้อผิดพลาดระหว่างโหลดข้อมูล กรุณาลองใหม่อีกครั้ง";
        })
        .then(function() {
          KTApp.unblockPage();
        });
    },

    // F13 (J2) — รวม Excel ทั้งชุดเป็น ZIP
    //   ใช้ popup ความคืบหน้าตัวเดียวกับตอนสร้างเอกสาร (F14) โดยสลับ endpoint
    //   งานนี้กินเวลาหลายนาทีเช่นกัน จึงต้องทำเบื้องหลัง ไม่ใช่รอในคำขอเดียว
    exportZipExcel: function() {
      if (!this.batchId || this.documentCount === 0) return;

      // FS-019 — จำไว้ว่างานที่กำลังจะรันเป็นฝั่งไหน ไว้ใช้ตอนรับ event finished
      this.zipJobKind = "excel";

      this.$refs.progressModal.start({
        title: "กำลังสร้างไฟล์ ZIP (Excel)",
        showTimer: true, // FS-126
        payload: { batchId: this.batchId },
        endpoints: {
          start: "/Api/FormSummaryStock/GroupZipExcelStart",
        },
      });
    },

    // F13 (J2) — รวมฟอร์ม PDF ทั้งชุดเป็น ZIP
    //   ใช้ popup ความคืบหน้าตัวเดียวกับฝั่ง Excel ต่างแค่ endpoint ที่เริ่มงาน
    //   งานนี้หนักกว่าฝั่ง Excel เพราะ BIRT render ทีละฉบับ
    exportZipPdf: function() {
      if (!this.batchId || this.documentCount === 0) return;

      // FS-019 — จำไว้ว่างานที่กำลังจะรันเป็นฝั่งไหน ไว้ใช้ตอนรับ event finished
      this.zipJobKind = "pdf";

      this.$refs.progressModal.start({
        title: "กำลังสร้างไฟล์ ZIP (PDF)",
        showTimer: true, // FS-126
        payload: { batchId: this.batchId },
        endpoints: {
          start: "/Api/FormSummaryStock/GroupZipPdfStart",
        },
      });
    },

    // FS-019 — งาน ZIP จบแล้ว (popup ความคืบหน้า emit "finished")
    //
    //   นับว่า "ทำแล้ว" ต่อเมื่อครบ 2 เงื่อนไข:
    //     1. state === "Completed"  — ไม่ใช่ Cancelled / Failed
    //        (ฝั่ง backend เรียก store.Complete(... Completed) เฉพาะตอนงานสำเร็จ)
    //     2. hasResultFile === true — มีไฟล์ ZIP ให้ดาวน์โหลดจริง
    //        ค่านี้อยู่บน popup ความคืบหน้า มาจาก GroupProgress
    //        (CompleteWithFile จะตั้งให้เฉพาะงานที่ผลิตไฟล์ได้สำเร็จ)
    //
    //   ไม่ผูกกับ "ผู้ใช้กดปุ่มดาวน์โหลดไฟล์แล้วหรือยัง" เพราะ popup ความคืบหน้า
    //   ไม่ได้ส่งสัญญาณนั้นออกมา และห้ามแก้ไฟล์นั้นในงานนี้
    onZipFinished: function(payload) {
      const info = payload || {};
      const modal = this.$refs.progressModal;
      const hasFile = !!(modal && modal.hasResultFile);

      if (info.state !== "Completed" || !hasFile) return;

      if (this.zipJobKind === "excel") {
        this.zipExcelDone = true;
      } else if (this.zipJobKind === "pdf") {
        this.zipPdfDone = true;
      }
    },

    // FS-019 — ประกอบเนื้อความ popup ยืนยันออกจากหน้า (3 ส่วนตาม design)
    //   1. ข้อความหลัก
    //   2. กล่องเหลืองรายการงานค้าง — แสดงเฉพาะเมื่อยังมีงานที่ยังไม่ได้ทำ
    //   3. กล่องหมายเหตุ
    //
    //   ใช้ style ฝังในบรรทัดโดยตั้งใจ: Swal สร้าง DOM ไว้นอก component
    //   ทำให้ <style scoped> ของไฟล์นี้ใช้ไม่ได้
    buildLeaveConfirmHtml: function() {
      const tasks = this.pendingZipTasks;

      let html =
        '<div style="text-align:left;" data-test="fss-leave-main">' +
        "เมื่อออกจากหน้านี้แล้ว จะไม่สามารถกลับมาเปิดดูหน้าสรุปผลรวมนี้ได้อีก" +
        "</div>";

      if (tasks.length > 0) {
        let items = "";

        for (let i = 0; i < tasks.length; i++) {
          items +=
            '<li data-test="fss-leave-pending-' +
            tasks[i].key +
            '" style="margin-top:0.25rem;">' +
            tasks[i].text +
            "</li>";
        }

        html +=
          '<div data-test="fss-leave-pending" style="text-align:left;' +
          "background-color:#fff4de;border:1px solid #ffd77a;" +
          "border-left:4px solid #ffb822;border-radius:4px;" +
          'padding:0.75rem 0.9rem;margin-top:0.9rem;color:#48465b;">' +
          "<strong>หากยังไม่ได้ดำเนินการต่อไปนี้ กรุณากลับไปดำเนินการก่อน:</strong>" +
          '<ul style="margin:0.5rem 0 0;padding-left:1.2rem;">' +
          items +
          "</ul>" +
          "</div>";
      }

      html +=
        '<div data-test="fss-leave-note" style="text-align:left;' +
        "background-color:#f7f8fa;border:1px solid #ebedf2;border-radius:4px;" +
        "padding:0.65rem 0.9rem;margin-top:0.9rem;color:#74788d;" +
        'font-style:italic;font-size:0.9rem;">' +
        "หมายเหตุ: เอกสารทั้งหมดที่สร้างสำเร็จแล้ว จะยังคงอยู่ในเมนู " +
        "&quot;รายการเอกสาร&quot; สามารถเปิดดูรายละเอียดและพิมพ์ทีละเอกสารได้ตามปกติ" +
        "</div>";

      return html;
    },

    // URL ของเอกสารรายฉบับ — ใช้ทั้งกับ href (คลิกกลาง/copy link ได้) และ window.open
    documentUrl: function(doc) {
      return "/PrintSummary/Barcodes/" + encodeURIComponent(doc.documentNo);
    },

    // FS-032 ข้อ 2 — เปิดเอกสารรายฉบับใน "แท็บใหม่"
    //
    //   ของเดิมใช้ router.push = เปลี่ยนหน้าในแท็บเดิม ซึ่งทำให้หน้าสรุปชุดนี้หายถาวร
    //   (เป็นหน้าชั่วคราวที่ spec บอกว่าแสดงครั้งเดียว)
    //
    //   ⚠ ต้องไม่ตั้ง leaveConfirmed ที่นี่ — ผู้ใช้ยังอยู่หน้าเดิม ไม่ได้ออกไปไหน
    //     ถ้าตั้งไว้ การออกจากหน้าครั้งถัดไปจะไม่เตือน (FS-019 พัง)
    //
    //   ตัด opener ทิ้งด้วยเหตุผลความปลอดภัย — แท็บใหม่ไม่ควรเข้าถึง window ของหน้านี้ได้
    viewDocument: function(doc) {
      const opened = window.open(this.documentUrl(doc), "_blank");
      if (opened) opened.opener = null;
    },

    /**
     * FS-054 — ปุ่ม "กลับสู่หน้าค้นหา" ต้องขึ้น popup ยืนยันเหมือนทางออกอื่น
     *
     * ของเดิมตั้ง leaveConfirmed = true ก่อน push ด้วยเหตุผลว่า
     * "กดปุ่มนี้ = ผู้ใช้ตั้งใจออกแล้ว" แต่สาระของ popup คือกันลืมดาวน์โหลด ZIP (FS-019)
     * และหน้านี้ spec บังคับว่าแสดงครั้งเดียว เปิดซ้ำไม่ได้ (FS-039 ข้อ 2)
     * คนที่กดปุ่มนี้จึงมีโอกาสลืมพอ ๆ กับคนที่ปิดแท็บ — ที่ผ่านมาทางออกที่คนใช้บ่อยที่สุด
     * กลับเป็นทางเดียวที่ไม่เตือน
     *
     * แก้ด้วยการ "ไม่ตั้ง leaveConfirmed" แล้วปล่อยให้ beforeRouteLeave เด้ง popup เอง
     * ได้ popup ตัวเดียวกันเป๊ะ ไม่ต้องเขียนซ้ำ และไม่มีทางเด้ง 2 ครั้ง
     */
    leaveToList: function() {
      router.push({ path: "/PrintSummary/Barcodes" });
    },

    // เตือนตอนปิดแท็บ / refresh / กด back ของเบราว์เซอร์
    onBeforeUnload: function(event) {
      if (this.leaveConfirmed) return undefined;

      // เบราว์เซอร์สมัยใหม่ไม่ให้กำหนดข้อความเอง — ต้อง preventDefault + returnValue
      event.preventDefault();
      event.returnValue = "";
      return "";
    },
  },
  mounted: function() {
    this.loadResult();
    window.addEventListener("beforeunload", this.onBeforeUnload);
  },
  beforeDestroy: function() {
    window.removeEventListener("beforeunload", this.onBeforeUnload);
  },
  // เตือนตอนเปลี่ยนหน้าภายใน SPA (spec: ออกแล้วต้องไปหาเอกสารทีละฉบับในหน้ารายการ)
  beforeRouteLeave: function(to, from, next) {
    if (this.leaveConfirmed || this.loadError) {
      next();
      return;
    }

    Swal.fire({
      title: "ยืนยันการออกจากหน้าสรุปผลการสร้างเอกสาร",
      html: this.buildLeaveConfirmHtml(),
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "ออกจากหน้า",
      cancelButtonText: "ยังอยู่หน้านี้",
      // FS-019 — ยกให้ "ยังอยู่หน้านี้" เป็นปุ่มหลัก
      //   focusCancel : ปุ่มที่โฟกัสอยู่คือปุ่มที่ Enter จะกดโดน จึงต้องเป็น
      //                 ตัวที่ปลอดภัย ไม่ใช่ตัวที่พาผู้ใช้ออกไปทั้งที่ยังไม่ได้โหลดไฟล์
      //   ไม่ใช้ reverseButtons — design วาง [ออกจากหน้า] ไว้ซ้าย [ยังอยู่หน้านี้] ไว้ขวา
      focusCancel: true,
    }).then(function(result) {
      // SweetAlert2 v8 — ผลการยืนยันอยู่ที่ result.value
      next(result.value === true);
    });
  },
};
</script>

<style scoped>
.fss-result__summary {
  background-color: #f7f8fa;
  border: 1px solid #ebedf2;
  border-radius: 4px;
  padding: 1rem 1.25rem;
  margin-bottom: 1rem;
}

/* FS-112 ข้อ 3 — ค่าตาม mockup ฉบับเซ็น : background #28a745 · color #fff · padding 8px 14px · radius 4px */
.fss-result__headline {
  background-color: #28a745;
  color: #fff;
  padding: 8px 14px;
  border-radius: 4px;
  font-size: 1.1rem;
}

.fss-result__count {
  margin: 0 0.15rem;
}

/* FS-121 — Filter ที่เลือก / ตาราง : ค่าเดียวกับขั้นที่ 2 (FormSummaryStockGroupPreview.vue) */
.fss-result__filter {
  margin-bottom: 1rem;
}

.fss-filter-table {
  margin-bottom: 0;
}

.fss-filter-table__label {
  width: 12rem;
  font-weight: 600;
  color: #6c7293;
}

.fss-total-row {
  background-color: #f7f8fa;
}

.fss-branch-line {
  margin-top: 0.25rem;
  color: #74788d;
  font-size: 0.85rem;
  font-weight: normal;
}

.fss-detail-row > td {
  background-color: #fafbfc;
}

.fss-detail {
  padding: 0.5rem 0.25rem;
}

.fss-detail__title {
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #6c7293;
}

.fss-result__bulk {
  margin-bottom: 1rem;
}

.fss-result__bulk-note {
  display: block;
  margin-top: 0.5rem;
  color: #74788d;
  font-size: 0.9rem;
}

/* FS-032 — ช่องค้นหาตัวแทนเหนือตาราง */
.fss-result__search {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
}

/* FS-053 ข้อ 2 — ช่องค้นหาต้องกว้างเท่าตาราง (เดิมกว้าง 320px ชิดซ้าย) */
.fss-result__search-box {
  width: 100%;
}

.fss-result__search-count {
  margin-left: 0.75rem;
  color: #74788d;
  font-size: 0.9rem;
}

.fss-result__empty {
  color: #74788d;
  font-style: italic;
}

/* FS-032 — เลขที่เอกสารเป็นลิงก์เปิดแท็บใหม่ */
.fss-result__doc-link {
  color: #5867dd;
  font-weight: 600;
  text-decoration: underline;
}

.fss-result__doc-link:hover {
  color: #3f51b5;
}

/* FS-032 — แถบเตือน "หน้าสรุปนี้แสดงเพียงครั้งเดียว" (อยู่ในหน้า ไม่ใช่ใน popup) */
.fss-result__once {
  display: flex;
  align-items: flex-start;
  background-color: #fff4de;
  border: 1px solid #ffd77a;
  border-left: 4px solid #ffb822;
  border-radius: 4px;
  padding: 0.75rem 0.9rem;
  margin-top: 1rem;
  color: #48465b;
  font-size: 0.95rem;
}

.fss-result__once i {
  color: #ffb822;
  margin-right: 0.6rem;
  margin-top: 0.15rem;
}

</style>



// WEBPACK FOOTER //
// App/Components/PrintSummary/FormSummaryStockGroupResult.vue